import { useState, useEffect } from 'react';
import { getPhotos } from '../lib/api/adminApi';

const CATEGORY_GRADIENTS = {
  'Salle de bain':    'linear-gradient(135deg, #052e16 0%, #14532d 40%, #22c55e 100%)',
  'Chauffage':        'linear-gradient(135deg, #422006 0%, #92400e 50%, #eab308 100%)',
  'Pompe à chaleur':  'linear-gradient(135deg, #052e16 0%, #15803d 55%, #4ade80 100%)',
  'Plomberie':        'linear-gradient(135deg, #0d1209 0%, #1a2216 50%, #22c55e 100%)',
  'Climatisation':    'linear-gradient(135deg, #450a0a 0%, #991b1b 50%, #ef4444 100%)',
};

const PLACEHOLDERS = [
  { id: 'ph-1', large: true,  cat: 'Salle de bain',   title: 'Salle de bain italienne complète — Paris 15e' },
  { id: 'ph-2',               cat: 'Chauffage',        title: 'Chaudière gaz condensation — Versailles' },
  { id: 'ph-3',               cat: 'Pompe à chaleur',  title: 'PAC air/eau — Meudon' },
  { id: 'ph-4',               cat: 'Plomberie',        title: 'Réseau de plomberie neuf — Boulogne' },
  { id: 'ph-5',               cat: 'Climatisation',    title: 'Multi-split gainable — Neuilly' },
];

const Realisations = () => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPhotos()
      .then(({ data }) => setPhotos(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const realisationPhotos = photos
    .filter(p => p.category !== 'Illustration RGE')
    .sort((a, b) => (b.category === 'Salle de bain') - (a.category === 'Salle de bain'));

  const items = realisationPhotos.length > 0
    ? realisationPhotos.slice(0, 5).map((p, i) => ({ ...p, large: i === 0, isReal: true }))
    : PLACEHOLDERS.map(p => ({ ...p, isReal: false }));

  return (
    <section className="section" id="realisations">
      <div className="section-inner">
        <div className="section-header">
          <div className="section-tag">Nos réalisations</div>
          <h2 className="section-title">Des chantiers qui parlent d'eux-mêmes</h2>
          <p className="section-subtitle">
            Chaque projet est unique. Découvrez quelques-unes de nos réalisations
            en plomberie, chauffage, salle de bain et pompe à chaleur.
          </p>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '48px 0', color: 'var(--color-text-muted)' }}>
            Chargement…
          </div>
        ) : (
          <>
            <div className="realisations-grid">
              {items.map(({ id, large, cat, title, url, fileName, isReal }) => (
                <div key={id} className={`realisation-item${large ? ' large' : ''}`}>
                  <div className="realisation-visual">
                    <div className="realisation-bg">
                      {isReal ? (
                        <img
                          src={url}
                          alt={title ?? fileName}
                          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                      ) : (
                        <div
                          style={{
                            background: CATEGORY_GRADIENTS[cat] ?? '#1a1a2e',
                            position: 'absolute', inset: 0,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                          }}
                        >
                          <span style={{
                            color: 'rgba(255,255,255,0.15)',
                            fontSize: '0.78rem', fontWeight: 600,
                            textTransform: 'uppercase', letterSpacing: '2px',
                          }}>
                            Photo à venir
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="realisation-overlay">
                      <div className="realisation-cat">{cat}</div>
                      <div className="realisation-name">{title ?? fileName}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {photos.length === 0 && (
              <p style={{ textAlign: 'center', marginTop: 32, color: 'var(--color-text-muted)', fontSize: '0.88rem' }}>
                Les photos de vos chantiers seront intégrées prochainement.
              </p>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default Realisations;
